import React from 'react';
import { motion } from 'framer-motion';
import { FaGithub, FaLinkedin, FaEnvelope } from 'react-icons/fa';
import './Hero.css';

const Hero = () => {
  return (
    <section id="home" className="hero section">
      <div className="hero-background">
        <div className="grid-pattern"></div>
      </div>
      
      <div className="container hero-content">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="hero-title">
            Hi, I'm <span className="gradient-text">Edson Alvarado</span>
          </h1>
          
          <motion.h2 
            className="hero-subtitle"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3, duration: 0.8 }}
          >
            Software Engineer
          </motion.h2>
          
          <motion.p 
            className="hero-description"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5, duration: 0.8 }}
          >
            Senior Java Backend Developer with strong expertise in designing and building scalable microservices architectures using Spring Boot and Spring Cloud. Experienced in developing secure RESTful APIs with Spring Security and JWT, working with PostgreSQL, MySQL, and MongoDB, and applying Clean Architecture and Design Patterns in enterprise environments. Skilled in cloud-based solutions (Azure), automated testing (JUnit, Mockito), and delivering high-performance, maintainable systems in agile teams.
          </motion.p>

          <motion.div 
            className="hero-buttons"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.7, duration: 0.8 }}
          >
            {/*
            <button className="btn-primary">
              View Projects
            </button>
            */}
            <button
  className="btn-secondary"
  onClick={() => {
    const link = document.createElement('a');
    link.href = '/documents/Resume.pdf';
    link.download = 'Resume-Edson-Alvarado.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }}
>
  Download CV
</button>
          </motion.div>

          <motion.div 
            className="hero-social"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.9, duration: 0.8 }}
          >
            {/*
            <a href="https://github.com/EdsonHatakeDev" target="_blank" rel="noopener noreferrer" className="social-link">
              <FaGithub />
            </a>
            */}
            <a href="https://www.linkedin.com/in/edson-alvarado-dev" target="_blank" rel="noopener noreferrer" className="social-link">
              <FaLinkedin />
            </a>
            <a href="mailto:edsondal1405@gmail.com" className="social-link">
              <FaEnvelope />
            </a>
          </motion.div>
        </motion.div>

        <motion.div 
          className="hero-code"
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.5, duration: 0.8 }}
        >
          <div className="code-window">
            <div className="code-header">
              <span className="code-dot red"></span>
              <span className="code-dot yellow"></span>
              <span className="code-dot green"></span>
            </div>
            <div className="code-content">
              <pre>
{`const developer = {
  name: "Edson Alvarado",
  rol: "Software Engineer",
  specialty: "Backend",
  skills: [
    "Java", "Spring Boot", 
    "Microservices", "PostgreSQL", 
    "Azure devops","JWT", 
    "WebSockets",  "Git", 
    "JavaScript" "TypeScript", 
    "React"
  ],
  learning: "Always",
  available: true
};`}
              </pre>
            </div>
          </div>
        </motion.div>
      </div>

      <div className="scroll-indicator">
        <div className="mouse"></div>
      </div>
    </section>
  );
};

export default Hero;
